/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { StyleSheet } from 'react-native';
import { PortalHost } from '@gorhom/portal';

import * as Layout from '@components/screen/Layout';
import BusinessTracker from '@/screens/home/components/sections/BusinessTracker';
import ProductFocus from '@/screens/home/components/sections/ProductFocus';
import RankingPerformance from '@/screens/home/components/sections/RankingPerformance';
import SalesBrand from '@/screens/home/components/sections/SalesBrand';
import BackButton from '@components/navbar/BackButton';
import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import ScrollContainer from '@components/global/ScrollContainer';
import GRNDashboard from '@/screens/businessTracker/components/GRNDashboard';

import { isWeb, isNative } from '@global/screens';
import Colors from '@global/colors';

// const defaultSizeIcon = { width: isWeb ? 14 : 18, height: 14 };
// const defaultStyleIcon = {
// 	...(!isNative
// 		? {
// 			...defaultSizeIcon,
// 			filter: isMobileWeb ? 'unset' : 'brightness(0) invert(1)',
// 		}
// 		: {}),
// 	marginRight: 5,
// };

// const TAB_MENU = [
// 	{
// 		label: 'Business Tracker',
// 		value: 'business',
// 		icon: require('@assets/img/icons/menu/business-tracker.svg'),
// 		icon_active: require('@assets/img/icons/menu/business-tracker-active.svg'),
// 	},
// ];

const BusinessTrackerScreen = (props) => {
  const scrollRef = useRef(null);
  const userId = useSelector((state) => state.auth.userId);
  const [isProductFocus, setIsProductFocus] = useState(false);
  const [isRanking, setIsRanking] = useState(false);
  const [isSalesBrand, setIsSalesBrand] = useState(false);
  const [activeMobileTab, setActiveMobileTab] = useState('business');
  const [activeTab, setActiveTab] = useState(
    props?.route?.params?.tab === 'grn' ? 'grn' : 'sales',
  );

  useEffect(() => {
    props.navigation.addListener('focus', () => {});
    return () => {
      props.navigation.removeListener('focus');
    };
  }, [userId]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (props?.route?.params?.section) {
        if (!isWeb) {
          const section = props.route.params.section;
          if (section == 'business') {
            setActiveMobileTab('business');
          } else {
            setActiveMobileTab('');
          }
        } else {
          props.navigation.setParams({ section: '' });
        }
      }
      if (props?.route?.params?.tab) {
        const tab = props.route.params.tab;
        if (tab == 'product-focus') {
          if (!isProductFocus) {
            setIsProductFocus(true);
            onSetHeaderOption('product-focus');
          }
        } else if (tab == 'sales-brand') {
          if (!isRanking) {
            setIsSalesBrand(true);
            onSetHeaderOption('sales-brand');
          }
        } else if (tab == 'ranking') {
          if (!isRanking) {
            setIsRanking(true);
            onSetHeaderOption('ranking');
          }
        } else if (tab == 'grn') {
          setActiveTab('grn');
          if (isProductFocus) {
            setIsProductFocus(false);
          }
          if (isRanking) {
            setIsRanking(false);
          }
        } else if (tab == 'sales') {
          setActiveTab('sales');
          if (isProductFocus) {
            setIsProductFocus(false);
          }
          if (isRanking) {
            setIsRanking(false);
          }
        } else {
          if (isProductFocus) {
            setIsProductFocus(false);
          }
          if (isRanking) {
            setIsRanking(false);
          }
        }
      }
    }
    return () => {
      mounted = false;
    };
  }, [props.route]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (isNative) {
        if (scrollRef?.current) {
          scrollRef.current.scrollTo({ x: 0, animated: true });
        }
      }
    }
    return () => {
      mounted = false;
    };
  }, [isProductFocus, isRanking, isSalesBrand, activeMobileTab]);

  const onSetHeaderOption = (type) => {
    if (!isWeb) {
      props.navigation.setOptions({
        headerLeft: () => (
          <BackButton
            {...props}
            onPress={() => {
              if (type == 'product-focus') {
                setIsProductFocus(false);
                setActiveMobileTab('business');
                props.navigation.setParams({ tab: '', section: 'business' });
              } else if (type == 'sales-brand') {
                setIsSalesBrand(false);
                setActiveMobileTab('business');
                props.navigation.setParams({ tab: '', section: 'business' });
              }
              props.navigation.setOptions({
                headerLeft: () => <HamburgerButton {...props} />,
                headerRight: () => <NotificationSettingButton {...props} />,
                title: 'Business Tracker',
              });
            }}
          />
        ),
        headerRight: null,
        title:
          type == 'product-focus'
            ? 'Product Focus by Brand'
            : type == 'sales-brand'
            ? 'Sales Brand - MTD'
            : 'Ranking Performance',
      });
    }
  };

  return (
    <>
      <Layout.Container
        style={!isWeb ? styles.mobileContainer : styles.containerWeb}>
        <ScrollContainer
          ref={scrollRef}
          style={styles.containerScrollWeb}
          showsVerticalScrollIndicator>
          {isProductFocus ? (
            <ProductFocus
              {...props}
              onBack={() => {
                setIsProductFocus(false);
                props.navigation.setParams({ tab: '' });
              }}
            />
          ) : isSalesBrand ? (
            <SalesBrand
              {...props}
              onBack={() => {
                setIsSalesBrand(false);
                props.navigation.setParams({ tab: '' });
              }}
            />
          ) : isRanking ? (
            <RankingPerformance
              {...props}
              onBack={() => {
                setIsRanking(false);
                props.navigation.setParams({ tab: '' });
              }}
            />
          ) : (
            <>
              {isWeb || activeMobileTab == 'business' ? (
                <>
                  {activeTab === 'grn' ? (
                    <GRNDashboard />
                  ) : (
                    <BusinessTracker
                      {...props}
                      onOpenProductFocus={() => {
                        setIsProductFocus(true);
                        onSetHeaderOption('product-focus');
                        props.navigation.setParams({
                          tab: 'product-focus',
                          ...(!isWeb ? { section: 'business' } : {}),
                        });
                      }}
                      onOpenSalesBrand={() => {
                        setIsSalesBrand(true);
                        onSetHeaderOption('sales-brand');
                        props.navigation.setParams({
                          tab: 'sales-brand',
                          ...(!isWeb ? { section: 'business' } : {}),
                        });
                      }}
                    />
                  )}
                </>
              ) : (
                false
              )}
            </>
          )}
        </ScrollContainer>
      </Layout.Container>
      {/* Tab Menu Start */}
      {/* {!isWeb && !isProductFocus && !isRanking ? (
        <View style={styles.tabMobileWrapper}>
          {TAB_MENU.map((item, idx) => (
            <TouchableOpacity
              activeOpacity={0.8}
              style={[
                styles.tabItem,
                idx == 1 ? styles.tabItemMiddleSalesman : {},
              ]}
              onPress={() => {
                setActiveMobileTab(item.value);
                if (isProductFocus) {
                  setIsProductFocus(false);
                }
                if (isRanking) {
                  setIsRanking(false);
                }
                props.navigation.setParams({
                  tab: props?.route?.params?.tab,
                  section: item.value,
                });
              }}
              key={idx}>
              <Image
                width={defaultSizeIcon.width}
                height={defaultSizeIcon.height}
                style={defaultStyleIcon}
                svg={true}
                source={
                  activeMobileTab == item.value && !isWeb
                    ? item.icon_active
                    : item.icon
                }
              />
              <SociollaText
                style={[
                  styles.tabItemText,
                  activeMobileTab == item.value ? styles.tabItemTextActive : {},
                ]}>
                {item.label}
              </SociollaText>
            </TouchableOpacity>
          ))}
        </View>
      ) : (
        false
      )} */}
      <PortalHost name="filter-product-focus" />
    </>
  );
};

const styles = StyleSheet.create({
  mobileContainer: {
    backgroundColor: Colors.grey5,
    paddingTop: 15,
    paddingBottom: 10,
    paddingHorizontal: 0,
  },
  containerWeb: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingHorizontal: 0,
  },
  containerScrollWeb: {
    paddingTop: isWeb ? 30 : 0,
    paddingBottom: 30,
    paddingHorizontal: isWeb ? 30 : 15,
  },
  // tabMobileWrapper: {
  // 	position: isNative ? 'absolute' : 'sticky',
  // 	bottom: 0,
  // 	left: 0,
  // 	right: 0,
  // 	zIndex: 10,
  // 	elevation: 10,
  // 	borderTopWidth: 1,
  // 	borderTopColor: Colors.grey0,
  // 	flexDirection: 'row',
  // 	alignItems: 'center',
  // 	justifyContent: 'space-around',
  // 	backgroundColor: Colors.white,
  // 	paddingVertical: 10,
  // },
  // tabItem: {
  // 	paddingVertical: 5,
  // 	paddingHorizontal: 15,
  // 	flexDirection: 'row',
  // 	alignItems: 'center',
  // },
  // tabItemMiddleSalesman: {
  // 	borderLeftWidth: 1,
  // 	borderLeftColor: Colors.grey0,
  // },
  // tabItemText: {
  // 	color: Colors.grey1,
  // 	fontSize: 12,
  // },
  // tabItemTextActive: {
  // 	color: Colors.blue0,
  // },
});

export default BusinessTrackerScreen;
